import styles from "./acardeon.module.css";
import { useMeals, useMealsAction } from "../../../../Context/MealsProvider";

import { AiOutlinePlus } from "react-icons/ai";
const AcardeonMian = ({ index, dayIndex }) => {
  const meals = useMeals();
  const dispatch = useMealsAction();
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion-${index}-${dayIndex}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  return (
    <div>
      <p>
        <button
          className={`btn ${styles.btnacardeon}`}
          type="button"
          onClick={toggleAccordion}
        >
          <AiOutlinePlus />
        </button>
      </p>
      <div className="collapse" id={`accordion-${index}-${dayIndex}`}>
        <div>
          <div className={styles.containerAcardeon}>
            <div className={styles.containerMain}>
              <div className={styles.formInput}>
                <p className={styles.text}>نام</p>
                <input
                  type="text"
                  className={styles.inputBox}
                  value={meals[dayIndex][index].onvan}
                  onChange={(e) =>
                    dispatch({
                      type: "changeHandlerOnvan",
                      day: dayIndex,
                      id: index,
                      event: e,
                    })
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AcardeonMian;
